import { Alert } from '@mui/material';

export interface ErrorMessageAlertProps {
  error: unknown;
}

export const ErrorMessageAlert = ({ error }: ErrorMessageAlertProps) => {
  const isError = (error: unknown): error is { message?: string } => {
    return typeof error === 'object' && error !== null && 'message' in error;
  };

  const extractErrorMessage = () => {
    if (isError(error)) {
      return `Error: ${Array.isArray(error.message) ? error.message.join('; ') : error.message}).`;
    }

    return `Unknown error occurred (Error: ${JSON.stringify(
      error,
    )}). Please try again later or contact My IPO client services.`;
  };

  return (
    <Alert severity='error' variant='filled'>
      {extractErrorMessage()}
    </Alert>
  );
};
